import React, { useEffect } from "react";
import { useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";
import "./redirect.css";
import Loader from "../../Loader/Loader";

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const Redirect = ({}) => {
  const searchParams = useQuery();
  const navigate = useHistory();

  useEffect(() => {
    if (searchParams) {
      const accessToken = searchParams.get("access_token");
      const refreshToken = searchParams.get("refresh_token");
      const roleId = searchParams.get("role_id");
      const redirect = searchParams.get("redirect_to");
      const name = searchParams.get("name");
      const userIdVal = searchParams.get("userId");
      const userId = searchParams.get("user_id");
      const isNewleadx = searchParams.get("is_new_leadx")

      if(!!isNewleadx){
        sessionStorage.setItem("isNewleadx", isNewleadx);
      }

      if (!!accessToken) {
        localStorage.setItem("token", accessToken);
      }

      if (!!refreshToken) {
        localStorage.setItem("refresh_token", refreshToken);
      }

      if (!!name) {
        localStorage.setItem("name", name);
      }

      if (!!userIdVal) {
        localStorage.setItem("userId", name);
      }

      if (!!userIdVal) {
        localStorage.setItem("userId", name);
      }

      if (!!userId) {
        localStorage.setItem("user_id", userId);
      }

      if (!!redirect) {
        if (!!roleId) {
          localStorage.setItem("role_id", roleId);
        }
        window.location.replace(redirect);
      }
    }
  }, [searchParams]);

  return (
    <div className="redirectBox">
      <Loader isLoading text="Please wait while we are redirecting you..." />
    </div>
  );
};

export default Redirect;
